
<div
    v-if  = "attachment"
    class="v-flex"
>
    <c-toolbar-button
        v-if     = "zoomAllowed"
        icon     = "mdi-arrow-expand-all"
        :color   = "color"
        :size    = "iconSize"
        :tooltip = "$t('inb.edit.menu.zoomon')"
        @click   = "onZoom"
    />

    <c-toolbar-button
        v-if     = "saveAllowed && editable && attachment.incidentId === null"
        icon     = "mdi-content-save-outline"
        :color   = "color"
        :size    = "iconSize"
        :tooltip = "$t('inb.edit.menu.save')"
        @click   = "onSave"
    />

    <c-toolbar-button
        v-if     = "saveAllowed && editable && attachment.incidentId === null && attachment.incidentType !== null && attachment.sites && attachment.sites.length > 0"
        icon     = "mdi-plus"
        :color   = "color"
        :size    = "iconSize"
        :tooltip = "$t('inb.edit.menu.create')"
        @click   = "onCreate"
    />

    <c-toolbar-button
        v-if     = "saveAllowed && editable && attachment.incidentId === null && attachment.incidentType !== null && attachment.incidentType !== null && attachment.sites && attachment.sites.length > 0"
        icon     = "mdi-pencil-plus-outline"
        :color   = "color"
        :size    = "iconSize"
        :tooltip = "$t('inb.edit.menu.creategoto')"
        @click   = "onCreateAndGoto"

    />
    <c-toolbar-button
        v-if     = "attachment.incidentId !== null"
        icon     = "mdi-arrow-left"
        :color   = "color"
        :size    = "iconSize"
        :tooltip = "$t('inb.edit.menu.goto')"
        @click   = "onGoto"
    />

    <!--
    <c-toolbar-button
        v-if     = "!this.attachment.ignore && !this.attachment.confirmed"
        icon     = "mdi-check"
        :color   = "color"
        :size    = "iconSize"
        :tooltip = "$t('inb.edit.menu.confirm')"
        @click   = "onConfirm"
    />
    <c-toolbar-button
        v-if     = "!attachment.ignore && attachment.confirmed && attachment.incidentId === null"
        icon     = "mdi-undo-variant"
        :color   = "color"
        :size    = "iconSize"
        :tooltip = "$t('inb.edit.menu.confirmReset')"
        @click   = "onConfirmReset"
    />
    -->
    <c-toolbar-button
        v-if     = "editable"
        icon     = "mdi-delete-outline"
        color   = "error"
        :size    = "iconSize"
        :tooltip = "$t('inb.edit.menu.ignore')"
        @click   = "onIgnore"
    />
    <c-toolbar-button
        v-if     = "attachment.ignore"
        icon     = "mdi-delete-restore"
        color    = "error"
        :size    = "iconSize"
        :tooltip = "$t('inb.edit.menu.ignoreReset')"
        @click   = "onIgnoreReset"
    />
</div>

